import React, { Suspense, useState, ErrorInfo, useEffect } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { useStateWithCallback } from './api/utils/useStateWithCallback';
import './App.css';

import { registerLicense, setCulture } from '@syncfusion/ej2-base';
import WordApp from './api/word';
import CollaborateWordApp from './api/cword';
import ExcelApp from './api/excel';
import CollaborateExcelApp from './api/cexcel';
import PDFApp from './api/pdf';
import CollaboratePDFApp from './api/cpdf';
import Loading from './api/loading';
import ErrorLoadingDocument from './api/errorloading';
import UnsupportedLink from './api/unsupportedlink';
import UnsupportedApp from './api/unsupportedApp';
import NoAccess from './api/noAccess';
import { IDocumentLoader, CreateDocumentLoader, _RequestParams } from './api/types/document';
import config from './config.json';
import { Errors } from './api/types/document';
import ImageApp from './api/image';

//registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9eeXVURmFdUkJzXUc=');
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1dcHVWRGFYVEZ+XEo=');
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXxccXRQQmdfU0V0V0s=');
registerLicense('Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9cc3VXQmJcVkNzWkFWYEg=');

function App() {
  
  const defaultLanguage : string = 'uk-UA';

  const serviceUrl : string = 'https://document.e-contentum.com/';

  const [ refreshSign, setRefreshSign ] = useStateWithCallback<boolean>(false,() => { });
  const [ enableRTL, setEnableRTL ] = useState<boolean>(false);

  const [ started, setStarted ] = useState<boolean>(false);
  const [ token, setToken ] = useState<string | null>(null);
  const [ systemId, setSystemId ] = useState<string | null>(null);
  const [ documentId, setDocumentId ] = useState<string | null>(null);
  const [ versionUid, setVersionUid ] = useState<string | null>(null);
  const [ userId, setUserId ] = useState<string | null>(null);
  const [ roomName, setRoomName ] = useState<string | null>(null);
  const [ version, setVersion ] = useState<number>(null!);

  const [ loadedSuccess, setLoadedSuccess ] = useStateWithCallback<number>(0,() => { });
  const [ documentLoader, setDocumentLoader ] = useState<IDocumentLoader>();

  setCulture('uk-UA');

  useEffect(() => {
    document.title = config.app.title;
  }, []);

  function loadDocument() : void {

    //document.title = 'Contentum document editor';
    //localStorage.setItem('appName', document.title);
    
    const queryString = window.location.href;
    
    const queryParams = new URLSearchParams(window.location.search);
    const token : any | any = queryParams.has('token') ? queryParams.get('token') : null;
    const id : any | any = queryParams.has('id') ? queryParams.get('id') : null;

    let collaborateMode : boolean = false;
    let externalMode : boolean = false;
    let loadFormData : any = new FormData();
    loadFormData.append('id', id);
    loadFormData.append('token', token);

    if (!token) {
      setLoadedSuccess(4);
      return ;
    }
    if (!id) {
      setLoadedSuccess(4);
      return ;
    }

    if (queryString.includes('collaborate/edit')) {
      collaborateMode = true;
    }

    if (queryString.includes('external/edit')) {
      externalMode = true;
    }
    //console.log('collaborateMode',collaborateMode)
    //console.log('externalMode',externalMode)
    //config.settings.collaborateBaseServerUrl + '/api/CollaborativeEditing/ImportFile'

    /*
    if (!collaborateMode && !externalMode) {

      fetch(config.settings.baseServerUrl + '/client/api/get', {
        method: 'POST',
        body: loadFormData
      })
      .then(async (resp: any) => {
        return resp;
      })
      .then(async (resp: any) => {
        if (resp.status != 200 && resp.status != 304) {
          const dl : IDocumentLoader = CreateDocumentLoader(Errors('Помилка підключення до сервера','Error connected to server: status=' + resp.status + ', text=' + resp.statusText));
          setDocumentLoader(dl);
          setLoadedSuccess(2);
        } else {
          const jsonObj : any = await resp.json();
          if (jsonObj.success) {
            const dl : IDocumentLoader = jsonObj.data as IDocumentLoader;
            console.log(dl);
            setDocumentLoader(dl);
            setSystemId(dl.requestParams.systemId);
            setDocumentId(dl.requestParams.documentId);
            setVersionUid(dl.requestParams.versionUid);
            setUserId(dl.requestParams.userId);
            setLoadedSuccess(dl.success ? 1 : 3);
            //if (dl.success && dl.document.metadata.supportedApp === 'WordApp') {
            //  await connectToSignalIR(dl);
            //}
          } else {
            const dl : IDocumentLoader = CreateDocumentLoader(Errors(jsonObj.ErrorMessage.Message,jsonObj.ErrorMessage.Details,jsonObj.ErrorMessage));
            setDocumentLoader(dl);
            setLoadedSuccess(3);
          }  
        }
      })
      .catch((error: Error) => {
        const dl : IDocumentLoader = CreateDocumentLoader(Errors('Server connection error','Error connected to server: ' + error.message,error));
        setDocumentLoader(dl);
        setLoadedSuccess(2);
      })

    } 
    */
   
    if (!collaborateMode && !externalMode) {

      var httpRequest = new XMLHttpRequest();
      httpRequest.open('Post', config.settings.collaborateBaseServerUrl + '/CollaborativeEditing/ImportPersistentFile' /*'/api/CollaborativeEditing/ImportFile'*/, true);
      //httpRequest.withCredentials = true;
      httpRequest.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      httpRequest.send(JSON.stringify({ "id": id, "token": token }));
      httpRequest.onerror = () => {
        const dl : IDocumentLoader = CreateDocumentLoader(Errors('Server connection error','Error connected to server: '));
        setDocumentLoader(dl);
        setLoadedSuccess(2);
      };
      httpRequest.onreadystatechange = () => {
          if (httpRequest.readyState === 4) {
              if (httpRequest.status === 200 || httpRequest.status === 304) {
                var jsonObj = JSON.parse(httpRequest.responseText);
                console.log(jsonObj);
                if (jsonObj.success) {
                  const dl : IDocumentLoader = jsonObj.data as IDocumentLoader;
                  console.log(dl);
                  setDocumentLoader(dl);
                  setSystemId(dl.requestParams.systemId);
                  setDocumentId(dl.requestParams.documentId);
                  setVersionUid(dl.requestParams.versionUid);
                  setUserId(dl.requestParams.userId);
                  setLoadedSuccess(dl.success ? 1 : 3);
                } else {
                  const dl : IDocumentLoader = CreateDocumentLoader(Errors(jsonObj.error.message,jsonObj.error.details));
                  setDocumentLoader(dl);
                  setLoadedSuccess(3);
                }  
              }
              else {
                const dl : IDocumentLoader = CreateDocumentLoader(Errors('Server connection error','Error connected to server: status=' + httpRequest.status + ', text=' + httpRequest.statusText));
                setDocumentLoader(dl);
                setLoadedSuccess(2);
              }
          }
      };

    }

    if (externalMode) {

      fetch(config.settings.baseServerUrl + '/client/api/external/document/get', {
        method: 'POST',
        body: loadFormData
      })
      .then(async (resp: any) => {
        return resp;
      })
      .then(async (resp: any) => {
        if (resp.status != 200 && resp.status != 304) {
          const dl : IDocumentLoader = CreateDocumentLoader(Errors('Помилка підключення до сервера','Error connected to server: status=' + resp.status + ', text=' + resp.statusText));
          setDocumentLoader(dl);
          setLoadedSuccess(2);
        } else {
          const jsonObj : any = await resp.json();
          //console.log(jsonObj);
          if (jsonObj.success) {
            const dl : IDocumentLoader = jsonObj.data as IDocumentLoader;
            console.log(dl);
            setDocumentLoader(dl);
            setSystemId(dl.requestParams.systemId);
            setDocumentId(dl.requestParams.documentId);
            setVersionUid(dl.requestParams.versionUid);
            setUserId(dl.requestParams.userId);
            setLoadedSuccess(dl.success ? 1 : 3);
            //if (dl.success && dl.document.metadata.supportedApp === 'WordApp') {
            //  await connectToSignalIR(dl);
            //}
          } else {
            const dl : IDocumentLoader = CreateDocumentLoader(Errors(jsonObj.error.message,jsonObj.error.details,jsonObj.error));
            setDocumentLoader(dl);
            setLoadedSuccess(3);
          }  
        }
      })
      .catch((error: Error) => {
        const dl : IDocumentLoader = CreateDocumentLoader(Errors('Server connection error','Error connected to server: ' + error.message,error));
        setDocumentLoader(dl);
        setLoadedSuccess(2);
      })

    }
  
    if (collaborateMode) {

      var httpRequest = new XMLHttpRequest();
      httpRequest.open('Post', config.settings.collaborateBaseServerUrl + '/CollaborativeEditing/ImportFile' /*'/api/CollaborativeEditing/ImportFile'*/, true);
      //httpRequest.withCredentials = true;
      httpRequest.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      httpRequest.send(JSON.stringify({ "id": id, "token": token }));
      httpRequest.onerror = () => {
        const dl : IDocumentLoader = CreateDocumentLoader(Errors('Server connection error','Error connected to server: '));
        setDocumentLoader(dl);
        setLoadedSuccess(2);
      };
      httpRequest.onreadystatechange = () => {
          if (httpRequest.readyState === 4) {
              if (httpRequest.status === 200 || httpRequest.status === 304) {
                var jsonObj = JSON.parse(httpRequest.responseText);
                console.log(jsonObj);
                if (jsonObj.Success) {
                  const dl : IDocumentLoader = {
                    success:jsonObj.Success,
                    invalidUrl: jsonObj.data.invalidUrl,
                    error: { message: jsonObj.ErrorMessage.Message, details: jsonObj.ErrorMessage.Details },
                    requestParams: jsonObj.data.requestParams,
                    user: jsonObj.data.user,
                    document: {
                      name: jsonObj.data.document.name,
                      metadata: jsonObj.data.document.metadata,
                      access: jsonObj.data.document.access,
                      //body: jsonObj.Sfdt,
                      body: jsonObj.Sfdt ? jsonObj.Sfdt : jsonObj.body
                    }
                  } as IDocumentLoader;
                  console.log(dl);
                  setRoomName(jsonObj.roomName);
                  setVersion(jsonObj.Version);
                  setDocumentLoader(dl);
                  setSystemId(dl.requestParams.systemId);
                  setDocumentId(dl.requestParams.documentId);
                  setVersionUid(dl.requestParams.versionUid);
                  setUserId(dl.requestParams.userId);
                  setLoadedSuccess(dl.success ? 1 : 3);
                } else {
                  const dl : IDocumentLoader = CreateDocumentLoader(Errors(jsonObj.ErrorMessage.Message,jsonObj.ErrorMessage.Details,jsonObj.ErrorMessage));
                  setDocumentLoader(dl);
                  setLoadedSuccess(3);
                }  
              }
              else {
                const dl : IDocumentLoader = CreateDocumentLoader(Errors('Server connection error','Error connected to server: status=' + httpRequest.status + ', text=' + httpRequest.statusText));
                setDocumentLoader(dl);
                setLoadedSuccess(2);
              }
          }
      };

    }

  }

  function reloadDocument() {
    setLoadedSuccess(0, () => {
      loadDocument();
    })
  }

  function useOnceCall(cb: any, condition = true) {
    const isCalledRef = React.useRef(false);

    React.useEffect(() => {
      if (condition && !isCalledRef.current) {
        isCalledRef.current = true;
        cb();
      }
    }, [cb, condition]);
  }

  useOnceCall(() => {
    loadDocument();
  });

  interface ErrorBoundaryProps {
    children: React.ReactNode;
  }
  
  interface ErrorBoundaryState {
    hasError: boolean;
  }

  class ErrorBoundary extends React.Component <ErrorBoundaryProps,ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
      super(props);
      this.state = { hasError: false };
    }
  
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
      console.error('ErrorBoundary caught an error: ', error, errorInfo);
      this.setState({ hasError: true });
    }
  
    render() {
      if (this.state.hasError) {
        return <h1>Something went wrong.</h1>;
      }
  
      return this.props.children;
    }
  }
  
  return (
    !refreshSign ? 
      <ErrorBoundary>
        <div className="App" style={{ width: '100hv', height: '100vh' }}>
          
          {loadedSuccess === 4 && <UnsupportedLink />}

          {documentLoader ?
            <React.Fragment>
              {documentLoader.invalidUrl ? <UnsupportedLink /> :
                <BrowserRouter>
                  <Suspense>
                    <Routes>
                      <Route path="/edit" element=
                        {
                          <React.Fragment>
                            {loadedSuccess === 0 &&
                              <Loading />
                            }
                            {loadedSuccess === 1 && documentLoader.document.access.allowRead &&
                              <React.Fragment>
                                {documentLoader?.document.metadata.supportedApp === 'WordApp' && <WordApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'ExcelApp' && <ExcelApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'PDFApp' && <PDFApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'ImageApp' && <ImageApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'UnsupportedApp' && <UnsupportedApp documentLoader={documentLoader!} />}
                              </React.Fragment>
                            }
                            {loadedSuccess === 1 && !documentLoader.document.access.allowRead &&
                              <NoAccess documentLoader={documentLoader!} />
                            }
                            {
                              loadedSuccess === 2 &&
                                <ErrorLoadingDocument reload={reloadDocument} documentLoader={documentLoader!} message={'Не вдалося отримати відповідь від сервера Contentum'} />
                            }
                            {
                              loadedSuccess === 3 &&
                                <ErrorLoadingDocument reload={reloadDocument} documentLoader={documentLoader!} message={'Неможливо отримати документ з системи Contentum'} />
                            }
                          </React.Fragment>
                        } 
                      />
                      <Route path="/external/edit" element=
                        {
                          <React.Fragment>
                            {loadedSuccess === 0 &&
                              <Loading />
                            }
                            {loadedSuccess === 1 && documentLoader.document.access.allowRead &&
                              <React.Fragment>
                                {documentLoader?.document.metadata.supportedApp === 'WordApp' && <WordApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'ExcelApp' && <ExcelApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'PDFApp' && <PDFApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'ImageApp' && <ImageApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                                {documentLoader?.document.metadata.supportedApp === 'UnsupportedApp' && <UnsupportedApp documentLoader={documentLoader!} />}
                              </React.Fragment>
                            }
                            {loadedSuccess === 1 && !documentLoader.document.access.allowRead &&
                              <NoAccess documentLoader={documentLoader!} />
                            }
                            {
                              loadedSuccess === 2 &&
                                <ErrorLoadingDocument reload={reloadDocument} documentLoader={documentLoader!} message={'Не вдалося отримати відповідь від сервера Contentum'} />
                            }
                            {
                              loadedSuccess === 3 &&
                                <ErrorLoadingDocument reload={reloadDocument} documentLoader={documentLoader!} message={'Неможливо отримати документ з системи Contentum'} />
                            }
                          </React.Fragment>
                        } 
                      />
                      <Route path="/collaborate/edit" element={
                        <React.Fragment>
                          {loadedSuccess === 0 &&
                            <Loading />
                          }
                          {loadedSuccess === 1 && documentLoader.document.access.allowEdit && 
                            <React.Fragment>
                              {documentLoader?.document.metadata.supportedApp === 'WordApp' && <CollaborateWordApp roomName={roomName} version={version} enableRTL={enableRTL} documentLoader={documentLoader!} />}
                              {documentLoader?.document.metadata.supportedApp === 'ExcelApp' && <CollaborateExcelApp /*roomName={roomName} version={version} enableRTL={enableRTL} documentLoader={documentLoader!} *//>}
                              {documentLoader?.document.metadata.supportedApp === 'PDFApp' && <CollaboratePDFApp enableRTL={enableRTL} documentLoader={documentLoader!} />}
                              {documentLoader?.document.metadata.supportedApp === 'UnsupportedApp' && <UnsupportedApp documentLoader={documentLoader!} />}
                            </React.Fragment>
                          }
                          {loadedSuccess === 1 && !documentLoader.document.access.allowEdit &&
                            <NoAccess documentLoader={documentLoader!} />
                          }
                          {
                            loadedSuccess === 2 &&
                              <ErrorLoadingDocument reload={reloadDocument} documentLoader={documentLoader!} message={'Не вдалося отримати відповідь від сервера Contentum'} />
                          }
                          {
                            loadedSuccess === 3 &&
                              <ErrorLoadingDocument reload={reloadDocument} documentLoader={documentLoader!} message={'Неможливо отримати документ з системи Contentum'} />
                          }
                        </React.Fragment>
                      }/>
                      <Route path="*" element={<UnsupportedLink />} />
                    </Routes>
                  </Suspense>
                </BrowserRouter>
              }
            </React.Fragment>
                
            : started ? <UnsupportedLink /> : loadedSuccess === 4 ? <></> : <Loading />
          }
        </div>
      </ErrorBoundary>
      : <React.Fragment></React.Fragment>
    );
    
  }

  export default App;
